import { Reducer } from "redux";

import { AuthorizationDetailTabsResponse } from "../models/Api/Authorization";
import { AuthorizationDetailTabsDispatchTypes } from "../models/DispatchTypes/Authorization";
import { AuthorizationDetailTabsActionDispatchTypes } from "../constants/Authorization";

export const initialState: AuthorizationDetailTabsResponse = {
  loading: false,
  response: {
    diseasesDto: [],
    psychologicalDiseasesDto: [],
    icdCodesInfoDto: [],
    authorizationGeneralInfoDto: null,
    requester: null,
    referralSource: null,
    originalIcdCodesInfoDto: null
  },
};

const AuthorizationDetailTabsReducer: Reducer<
  AuthorizationDetailTabsResponse,
  AuthorizationDetailTabsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AuthorizationDetailTabsActionDispatchTypes.GET_AUTH_DETAIL_TABS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AuthorizationDetailTabsActionDispatchTypes.GET_AUTH_DETAIL_TABS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case AuthorizationDetailTabsActionDispatchTypes.GET_AUTH_DETAIL_TABS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default AuthorizationDetailTabsReducer;
